import { bind } from '@react-rxjs/core'
import { createSignal } from '@react-rxjs/utils'
import { Subject } from 'rxjs'

const openChatbotSubject = new Subject<void>()

export const openChatbot$ = openChatbotSubject.asObservable()

export const openChatbot = (): void => openChatbotSubject.next()

const [chatIsOpenChange$, setChatIsOpen] = createSignal<boolean>()
export { setChatIsOpen }
export const [useChatIsOpen, chatIsOpen$] = bind(chatIsOpenChange$, false)

const [chatHasOpenedChange$, setChatHasOpened] = createSignal<boolean>()
export { setChatHasOpened }
export const [useChatHasOpened, chatHasOpened$] = bind(chatHasOpenedChange$, false)
